import type { PlatformServices } from "./PlatformServices";

/**
 * Returns whether the application may offer ways to buy: the billing page with plans, checkout,
 * customer portal, invoices and billing profile, the registration of a company, payment requests
 * and plan hints. The native apps never do, because the stores allow neither selling outside
 * their own billing nor pointing to it (ADR-0087 decision 1); billing stays in the PWA in the
 * browser and in e-mails.
 *
 * @param platform - The platform services chosen in the composition root.
 * @returns `true` in the browser and the installed PWA, `false` in the native apps.
 */
export function offersPurchasePaths(platform: Pick<PlatformServices, "isNative">): boolean {
  const offers = !platform.isNative;

  return offers;
}
